module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "myPicCut container cropBox"
  }, [_c('div', [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.url,
      "alt": "Picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "buttonList"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "warn",
      "show-loading": _vm.loading,
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.crop($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25fa0e44"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picCut/picCut.vue
// module id = 234
// module chunks = 28